/**
 * TouchVue UI 组件解析器
 * 用于支持 unplugin-auto-import 和 unplugin-vue-components 插件
 */

// 组件库名称
const LIBRARY_NAME = '@touchvue/ui'
// 组件前缀
const PREFIX = 'To'

/**
 * 检查组件名称是否符合规则
 * @param name 组件名称
 * @returns 是否符合规则
 */
const isValidComponentName = (name: string): boolean => {
	return name.startsWith(PREFIX)
}

const getSideEffectsPath = (prefix: string = LIBRARY_NAME): string[] | false => {
	const entry = `${prefix}/theme/index.css`
	return [entry]
}

/**
 * 组件解析器
 * 用于 unplugin-vue-components 插件
 */
export function TouchVueResolver() {
	return [
		{
			type: 'component',
			resolve: (name: string) => {
				if (!isValidComponentName(name)) return
				// 引入所有的样式包
				const sideEffects = getSideEffectsPath()
				const result: any = {
					name,
					from: LIBRARY_NAME,
				}
				if (sideEffects !== false) {
					result.sideEffects = sideEffects
				}

				return result
			},
		},
		{
			type: 'directive',
			resolve: (name: string) => {
				return {
					name: 'v' + name,
					from: LIBRARY_NAME,
				}
			},
		},
	]
}

/**
 * 默认导出所有解析器
 */
export default {
	TouchVueResolver,
}
